import * as Yup from "yup";
import i18n from "../i18n";

export const LoginSchema = Yup.object({
  username: Yup.string().required(
    i18n.language === "en" ? "Username is required." : "اسم المستخدم مطلوب."
  ),
  password: Yup.string().required(
    i18n.language === "en" ? "Password is required." : "كلمة المرور مطلوبة."
  ),
});
